export default __webpack_public_path__ + "static/media/par6.c97cf04e.jpg";